export const colorPrimary = "#4EFF4E";
export const colorError = "#ff5722";
